// i18n.js
import i18n from "i18next"
import { initReactI18next } from "react-i18next"

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        reportHeader: "Overview",
        terms: {
          Spring: "Spring",
          Fall: "Fall",
          Winter: "Winter",
        },
        subjects: {
          Math: "Math",
          Mathematics: "Mathematics",
          Reading: "Reading",
          Language: "Language",
          Science: "Science",
          SpReading: "Reading (Spanish)",
        },
        grade: "Grade {{number}}",
        subScoreHeader: "Subscores - Smarter Balanced Assessment Standards Alignment",
        testSubjects: {
          "Overall Score": "Overall Score",
          "Math K-2 CCSS 2010 1.1": "Math K-2 CCSS 2010 1.1",
          "Math 2-5 CCSS 2010 1.1": "Math 2-5 CCSS 2010 1.1",
          "Math 6+ CCSS 2010 1.1": "Math 6+ CCSS 2010 1.1",
          "Algebra 1 CCSS 2010 1.1": "Algebra 1 CCSS 2010 1.1",
          "Algebra 2 CCSS 2010 1.1": "Algebra 2 CCSS 2010 1.1",
          "Geometry CCSS 2010 1.1": "Geometry CCSS 2010 1.1",
          "High School Integrated Math 1 CCSS 2010 1.1":
            "High School Integrated Math 1 CCSS 2010 1.1",
          "High School Integrated Math 2 CCSS 2010 1.1":
            "High School Integrated Math 2 CCSS 2010 1.1",
          "High School Integrated Math 3 CCSS 2010 1.1":
            "High School Integrated Math 3 CCSS 2010 1.1",
          "Language 2+ CCSS 2010 1.1": "Language 2+ CCSS 2010 1.1",
          "Reading K-2 CCSS 2010 1.1": "Reading K-2 CCSS 2010 1.1",
          "Reading 2-5 CCSS 2010 1.1": "Reading 2-5 CCSS 2010 1.1",
          "Reading 6+ CCSS 2010 1.1": "Reading 6+ CCSS 2010 1.1",
          "Science 2-5 for use with NGSS 2013 1.1": "Science 2-5 for use with NGSS 2013 1.1",
          "Science 6-8 for use with NGSS 2013 1.1": "Science 6-8 for use with NGSS 2013 1.1",
          "Science 9-12 Life Science for use with NGSS 2013 1.1":
            "Science 9-12 Life Science for use with NGSS 2013 1.1",
          "Science 9-12 for use with NGSS 2013 1.1": "Science 9-12 for use with NGSS 2013 1.1",
          "Spanish Math K-2 CCSS 2010 V2": "Spanish Math K-2 CCSS 2010 V2",
          "Spanish Math 2-5 CCSS 2010 1.1": "Spanish Math 2-5 CCSS 2010 1.1",
          "Spanish Math 2-5 CCSS 2010 V2": "Spanish Math 2-5 CCSS 2010 V2",
          "Spanish Math 6+ CCSS 2010 1.1": "Spanish Math 6+ CCSS 2010 1.1",
          "Spanish Reading K-2 CCSS 2012": "Spanish Reading K-2 CCSS 2012",
          "Spanish Reading 2-5 CCSS 2012 V2": "Spanish Reading 2-5 CCSS 2012 V2",
          "Spanish Reading 6-8 CCSS 2012 V2": "Spanish Reading 6-8 CCSS 2012 V2",
          Subscores: "Subscores",
          "Operations and Algebraic Thinking": "Operations and Algebraic Thinking",
          "Number and Operations": "Number and Operations",
          "Measurement and Data": "Mesaurement and Data",
          Geometry: "Geometry",
          "Literary Text": "Literary Text",
          "Informational Text": "Informational Text",
          Vocabulary: "Vocabulary",
          "Language 2 +": "Language 2 +",
          "Writing Write, Revise Texts for Purpose and Audience":
            "Writing: Write, Revise Texts for Purpose and Audience",
          "Language Understand, Edit for Grammar, Usage":
            "Language: Understand, Edit for Grammar, Usage",
          "Language Understand, Edit for Mechanics": "Language: Understand, Edit for Mechanics",
          "Science 2-5": "Science 2-5",
          "Life Science": "Life Science",
          "Physical Science": "Physical Science",
          "Earth and Space Science": "Earth and Space Science",
          "Texto literario": "Literary text",
          "Texto informativo": "Informative text",
          Vocabulario: "Vocabulary",
        },
        definitions: {
          title: "Definitions",
          score: {
            title: "RIT Score",
            desc:
              "The student’s overall score on the test. This is a grade independent measure of item difficulty that ranges from 100-350.",
          },
          rank: {
            title: "Percentile Rank",
            desc:
              "The percentage of students in the national norms group for this grade, subject, and test administration season that this student’s score equaled or exceeded.",
          },
          growth: {
            title: "{{season}} to {{season}} Growth",
            desc:
              "An indicator of how much the student’s score increased since the previous Fall, compared to other students with similar scores in the same grade and season.",
          },
          range: {
            title: "Quantile & Lexile Range",
            desc:
              "A score (displayed as a 150-point range) resulting from a correlation between NWEA’s RIT score and the Quantile or Lexile scale that helps identify reading material that is at an appropriate difficulty level for an individual student.",
          },
        },
        rating: {
          above: "above average",
          below: "below average",
        },
        studentContext: "{{firstName}}'s {{testSubject}} score is <b>{{rating}}</b> compared to ",
        studentsEnrolledIn: "students enrolled in {{testSubject}} course",
        gradersIn: "graders in {{season}}",
        and: "and",
        increasedText: "increased {{compared}}",
        thanAcademicPeers: "than academic peers scores",
        sinceLast: "since last {{season}}",
        more: "More information about the Lexile framework may be found:",
        RITGrowthTime: "Rit Growth Over Time",
        RITScore: "RIT Score",
        Grade: "Grade",
        scale: {
          novice: "Novice",
          developing: "Developing",
          proficient: "Proficient",
          advanced: "Advanced",
        },
        showRITRanges:
          "show the RIT ranges aligned to Smarter Balanced Assessment standards for the student's grade and season.",
        scaleNorm: {
          low: "Low",
          lowAvg: "Low Avg",
          avg: "Average",
          hiAvg: "High Average",
          hi: "High",
        },
        normBasedMsg: "are based on NWEA's 2020 National Norm Study.",
        report_title: "Report",
        description: "This is the report description.",
        learningStatementsHeader: "Learning Statements",
        aboutHeader: "ABOUT THIS SECTION",
        aboutP1:
          "The columns below present examples of topics that your student may have seen on their assessment.",
        aboutP2:
          "The <h>LEFT COLUMN</h> shows examples of topics they answered correctly 75% of the time.*",
        aboutP3:
          "The <h>RIGHT COLUMN</h> shows examples of topics they answered correctly 50% of the time.*",
        aboutP4:
          "By default, this report is filtered to show learning statements for your student's current grade as well as one grade below and one grade above. Use the toggle above to display learning statements for all grades. Because many of these skills are broad, they may be in both columns. This means your child is likely to be successful in simpler applications of the skill, but is still developing the ability for more complex applications.",
        aboutP5:
          "* NOTE: There are only 43 questions on each MAP Growth test, and MAP Growth has test questions that assess upwards of several hundred individual skills. The information shown below displays the types of topics your student may have seen on the test, but does not identify which specific topics your student saw on the test.",
        howToHeader: "HOW TO INTERPRET THE EXAMPLES ON THIS REPORT",
      },
    },
    es: {
      translation: {
        reportHeader: "Descripción General",
        terms: {
          Spring: "Primavera",
          Fall: "Otoño",
          Winter: "Invierno",
        },
        subjects: {
          Math: "Matemáticas",
          Mathematics: "Matemáticas",
          Reading: "Lectura",
          Language: "Uso del Lenguaje",
          Science: "Ciencias",
          SpReading: "Lectura (Español)",
        },
        grade: "Grado {{number}}",
        subScoreHeader:
          "Subpuntajes - Alineación con los Estándares de Evaluación Smarter Balanced",
        subScoreOnly: "Subpuntajes",
        definitions: {
          title: "Definiciones",
          score: {
            title: "Puntaje RIT",
            desc:
              "La puntuación general del estudiante en la prueba. Es una medida independiente del grado que va de 100 a 350.",
          },
          rank: {
            title: "Rango Percentil",
            desc:
              "El porcentaje de estudiantes en el grupo normativo nacional para este grado, materia y temporada de evaluación que el puntaje de este estudiante igualó o superó.",
          },
          growth: {
            title: "Crecimiento {{season}} a {{season}}",
            desc:
              "Un indicador de cuánto aumentó el puntaje del estudiante desde el otoño anterior, en comparación con otros estudiantes con puntajes similares en el mismo grado y temporada.",
          },
          range: {
            title: "Rango Cuantitativo y Lexile",
            desc:
              "Una puntuación (mostrada como un rango de 150 puntos) resultante de una correlación entre el puntaje RIT de NWEA y la escala Cuantitativa o Lexile, que ayuda a identificar material de lectura con un nivel de dificultad apropiado para un estudiante individual.",
          },
        },
        growth: {
          slow: "Lento",
          slowAvg: "Promedio Bajo",
          avg: "Promedio",
          fastAvg: "Promedio Alto",
          fast: "Rápido",
        },
        percentile: "Percentil",
        RIT: "RIT",
        seasonGrowth: "Crecimiento {{seasonName}} a {{seasonName}}",
        rating: {
          above: "encima del promedio",
          below: "por debajo del promedio",
        },
        studentContext:
          "El puntaje de {{testSubject}} de {{firstName}} está por <b>{{rating}}</b> en comparación con los estudiantes de ",
        studentsEnrolledIn: "estudiantes matriculados en el curso de {{subject}}",
        gradersIn: "grado en la {{season}}",
        and: "y",
        increasedText: "aumentado {{compared}}",
        thanAcademicPeers: "que los puntajes de los compañeros académicos",
        sinceLast: "desde el último {{season}}",
        more: "Se puede encontrar más información sobre el marco Lexile en:",
        RITGrowthTime: "Crecimiento del RIT a lo largo del tiempo",
        RITScore: "Puntaje RIT",
        Grade: "Grado",
        testSubjects: {
          "Overall Score": "Puntaje General",
          "Math K-2 CCSS 2010 1.1": "Matemáticas K-2 CCSS 2010 1.1",
          "Math 2-5 CCSS 2010 1.1": "Matemáticas 2-5 CCSS 2010 V2",
          "Math 6+ CCSS 2010 1.1": "Matemáticas 6+ CCSS 2010 1.1",
          "Algebra 1 CCSS 2010 1.1": "Álgebra 1 CCSS 2010 1.1",
          "Algebra 2 CCSS 2010 1.1": "Álgebra 2 CCSS 2010 1.1",
          "Geometry CCSS 2010 1.1": "Geometría CCSS 2010 1.1",
          "High School Integrated Math 1 CCSS 2010 1.1":
            "Matemáticas integradas de secundaria 1 CCSS 2010 1.1",
          "High School Integrated Math 2 CCSS 2010 1.1":
            "Matemáticas integradas de secundaria 2 CCSS 2010 1.1",
          "High School Integrated Math 3 CCSS 2010 1.1":
            "Matemáticas integradas de secundaria 3 CCSS 2010 1.1",
          "Language 2+ CCSS 2010 1.1": "Lenguaje 2+ CCSS 2010 1.1",
          "Reading K-2 CCSS 2010 1.1": "Lectura K-2 CCSS 2010 1.1",
          "Reading 2-5 CCSS 2010 1.1": "Lectura 2-5 CCSS 2010 1.1",
          "Reading 6+ CCSS 2010 1.1": "Lectura 6+ CCSS 2010 1.1",
          "Science 2-5 for use with NGSS 2013 1.1": "Ciencias 2-5 para usar con NGSS 2013 1.1",
          "Science 6-8 for use with NGSS 2013 1.1": "Ciencias 6-8 para usar con NGSS 2013 1.1",
          "Science 9-12 Life Science for use with NGSS 2013 1.1":
            "Ciencias 9-12 Ciencias de la vida para usar con NGSS 2013 1.1",
          "Science 9-12 for use with NGSS 2013 1.1": "Ciencias 9-12 para usar con NGSS 2013 1.1",
          "Spanish Math K-2 CCSS 2010 V2": "Matemáticas españolas K-2 CCSS 2010 V2",
          "Spanish Math 2-5 CCSS 2010 1.1": "Matemáticas españolas 2-5 CCSS 2010 1.1",
          "Spanish Math 2-5 CCSS 2010 V2": "Matemáticas españolas 2-5 CCSS 2010 V2",
          "Spanish Math 6+ CCSS 2010 1.1": "Matemáticas españolas 6+ CCSS 2010 1.1",
          "Spanish Reading K-2 CCSS 2012": "Lectura en español K-2 CCSS 2012",
          "Spanish Reading 2-5 CCSS 2012 V2": "Lectura en español 2-5 CCSS 2012 V2",
          "Spanish Reading 6-8 CCSS 2012 V2": "Lectura en español 6-8 CCSS 2012 V2",
          Subscores: "Subpuntajes",
          "Operations and Algebraic Thinking": "Operaciones y pensamiento algebraico",
          "Number and Operations": "Números y Operaciones",
          "Measurement and Data": "Medición y datos",
          Geometry: "Geometría",
          "Literary Text": "Texto literario",
          "Informational Text": "Texto informativo",
          Vocabulary: "Vocabulario",
          "Language 2 +": "Lenguaje 2 +",
          "Writing Write, Revise Texts for Purpose and Audience":
            "Escritura: Escribir y revisar textos para propósito y audiencia",
          "Language Understand, Edit for Grammar, Usage":
            "Lenguaje: Comprender y editar gramática y uso",
          "Language Understand, Edit for Mechanics": "Lenguaje: Comprender y editar mecánica",
          "Science 2-5": "Ciencia 2-5",
          "Life Science": "Ciencias de la Vida",
          "Physical Science": "Ciencias Físicas",
          "Earth and Space Science": "Ciencias de la Tierra y el Espacio",
          "Texto literario": "Texto literario",
          "Texto informativo": "Texto informativo",
          Vocabulario: "Vocabulario",
        },
        scale: {
          novice: "Novato",
          developing: "Desarrollando",
          proficient: "Proficiente",
          advanced: "Avanzado",
        },
        showRITRanges: "muestran los rangos RIT alineados con los estándares de evaluación.",
        scaleNorm: {
          low: "Bajo",
          lowAvg: "Promedio Bajo",
          avg: "Promedio",
          hiAvg: "Promedio Alto",
          hi: "Alto",
        },
        normBasedMsg: "se basan en el Estudio de las Normas Nacionales de NWEA de 2020.",
        report_title: "Informe",
        description: "Esta es la descripción del informe.",
        learningStatementsHeader: "Declaraciones de Aprendizaje",
        aboutHeader: "SOBRE ESTA SECCIÓN",
        aboutP1:
          "Las columnas de bajo presentan ejemplos de temas que su estudiante puede haber visto en su evaluación.",
        aboutP2:
          "La <h>COLUMNA DE LA IZQUIERDA</h> muestra ejemplos de temas que respondieron correctamente el 75% del tiempo.",
        aboutP3:
          "La <h>COLUMNA DE LA DERECHA</h> muestra ejemplos de temas que respondieron correctamente 50% del tiempo.",
        aboutP4:
          "Por defecto, este reporte está filtrado para mostrar declaraciones de aprendizaje para el grado actual de sus estudiantes. También mostramos declaraciones de aprendizaje para el grado anterior y el próximo grado. Usa el botón de arriba para exhibir las declaraciones de aprendizaje para todos los grados. Porque muchas de las habilidades son amplias se pueden aparecer en las dos columnas. Esto significa que es probable que su estudiante tenga éxito en una aplicación más fácil de la habilidad pero también sigue la capacidad para aplicaciones más complejas.",
        aboutP5: "",
        howToHeader: "CÓMO INTERPRETAR LOS EJEMPLOS EN ESTE INFORME",
      },
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
